"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_definition_1 = require("../form-definition");
var utilities_1 = require("../utilities");
var moment = require("moment");
var form_constants_1 = require("../form-definition/form-constants");
var programOperators = require("./program-operators");
var conditionTypes = form_definition_1.formRuleTypes.conditionTypes, operationTypes = form_definition_1.formRuleTypes.operationTypes;
/**
 * this function will check if a condition is met based on a given state.
 * Conditions cannot be evaluated for 'group' elements
 * @param {FormState} state the FormState
 * @param {FormCondition} condition the condition to be checked against the state
 * @returns true if the condition is met, and false if it is not.
 */
function conditionReducer(state, condition) {
    // determine if the condition is met based on conditionType and element information
    switch (condition.type) {
        case conditionTypes.operator: {
            var conditionResults = [];
            condition.conditions.forEach(function (subCondition) {
                conditionResults.push(conditionReducer(state, subCondition));
            });
            if (conditionResults.length === 0) {
                return true;
            }
            switch (condition.operator) {
                case operationTypes.And:
                    return conditionResults.every(function (result) { return result; });
                case operationTypes.Or:
                    return conditionResults.some(function (result) { return result; });
                default:
                    return false;
            }
        }
        case conditionTypes.static: {
            return condition.value;
        }
        case conditionTypes.programEmpty:
        case conditionTypes.programNotEmpty:
        case conditionTypes.programContains:
        case conditionTypes.programNotContains:
        case conditionTypes.programMatchesAny:
        case conditionTypes.programNotMatchesAny:
        case conditionTypes.programMatchesAll:
        case conditionTypes.programNotMatchesAll: {
            return programConditionReducer(state, condition);
        }
        case conditionTypes.empty:
        case conditionTypes.notEmpty:
        case conditionTypes.equal:
        case conditionTypes.notEqual:
        case conditionTypes.equalLabel:
        case conditionTypes.notEqualLabel:
        case conditionTypes.equalMaskedMulti:
        case conditionTypes.notEqualMaskedMulti:
        case conditionTypes.contains:
        case conditionTypes.containsString:
        case conditionTypes.notContainString:
        case conditionTypes.lessThan:
        case conditionTypes.lessThanOrEqual:
        case conditionTypes.greaterThan:
        case conditionTypes.greaterThanOrEqual:
        case conditionTypes.equalElement:
        case conditionTypes.notEqualElement:
        case conditionTypes.lessThanElement:
        case conditionTypes.lessThanOrEqualElement:
        case conditionTypes.greaterThanElement:
        case conditionTypes.greaterThanOrEqualElement:
        case conditionTypes.beginsWith:
        case conditionTypes.notBeginWith:
        case conditionTypes.endsWith:
        case conditionTypes.notEndWith:
        case conditionTypes.matchesAny:
        case conditionTypes.notMatchAny:
        case conditionTypes.matchesAnyMaskedMulti:
        case conditionTypes.notMatchAnyMaskedMulti:
        case conditionTypes.matchesEvery:
        case conditionTypes.notMatchEvery:
        case conditionTypes.earlierThanNow:
        case conditionTypes.earlierThanNowOrEqual:
        case conditionTypes.laterThanNow:
        case conditionTypes.laterThanNowOrEqual:
        case conditionTypes.between:
        case conditionTypes.notBetween:
        case conditionTypes.today:
        case conditionTypes.notToday:
        case conditionTypes.thisWeek:
        case conditionTypes.notThisWeek:
        case conditionTypes.thisMonth:
        case conditionTypes.notThisMonth:
        case conditionTypes.thisYear:
        case conditionTypes.notThisYear:
        case conditionTypes.last:
        case conditionTypes.notLast:
        case conditionTypes.next:
        case conditionTypes.notNext:
            return elementConditionReducer(state, condition);
        default: return false;
    }
}
exports.conditionReducer = conditionReducer;
/**
 * Function that will evaluate conditions that deal with elements
 * @param state form state
 * @param condition form element condition
 */
function elementConditionReducer(state, condition) {
    var elementId = condition.elementId, conditionType = condition.type;
    var element = form_definition_1.getElementById(state, elementId);
    // can evaluate if groups are empty/notEmpty
    if (!element || (element.type === form_definition_1.elementTypes.group && !isValidGroup(element, condition)))
        return false;
    var elementValue = form_definition_1.getValue(state, elementId);
    switch (condition.type) {
        case conditionTypes.equal:
            return checkEquality(element, elementValue, condition.value, state);
        case conditionTypes.notEqual:
            return !checkEquality(element, elementValue, condition.value, state);
        case conditionTypes.equalLabel:
            return checkEqualityLabel(element, elementValue, condition.value, state);
        case conditionTypes.notEqualLabel:
            return !checkEqualityLabel(element, elementValue, condition.value, state);
        case conditionTypes.equalMaskedMulti:
            return checkEqualityMaskedMulti(element, elementValue, condition.value, state);
        case conditionTypes.notEqualMaskedMulti:
            return !checkEqualityMaskedMulti(element, elementValue, condition.value, state);
        case conditionTypes.empty:
            return checkEmpty(element, elementValue, state);
        case conditionTypes.notEmpty:
            return !checkEmpty(element, elementValue, state);
        case conditionTypes.contains:
            return checkContains(element, elementValue, condition.value);
        case conditionTypes.containsString:
            return checkContainsString(element, elementValue, condition.value, state);
        case conditionTypes.notContainString:
            return checkNotContainString(element, elementValue, condition.value, state);
        case conditionTypes.equalElement:
            return checkEqualElement(state, element, elementValue, condition.value);
        case conditionTypes.notEqualElement:
            return !checkEqualElement(state, element, elementValue, condition.value);
        case conditionTypes.lessThan:
            return checkLessThan(element, elementValue, condition.value, state);
        case conditionTypes.lessThanOrEqual:
            return checkLessThanOrEqual(element, elementValue, condition.value, state);
        case conditionTypes.greaterThan:
            return checkGreaterThan(element, elementValue, condition.value, state);
        case conditionTypes.greaterThanOrEqual:
            return checkGreaterThanOrEqual(element, elementValue, condition.value, state);
        case conditionTypes.equalElement:
            return checkEqualElement(state, element, elementValue, condition.value);
        case conditionTypes.notEqualElement:
            return !checkEqualElement(state, element, elementValue, condition.value);
        case conditionTypes.lessThanElement:
            return checkLessThanElement(state, element, elementValue, condition.value);
        case conditionTypes.lessThanOrEqualElement:
            return checkLessThanOrEqualElement(state, element, elementValue, condition.value);
        case conditionTypes.greaterThanElement:
            return checkGreaterThanElement(state, element, elementValue, condition.value);
        case conditionTypes.greaterThanOrEqualElement:
            return checkGreaterThanOrEqualElement(state, element, elementValue, condition.value);
        case conditionTypes.beginsWith:
            return checkBeginsWith(element, elementValue, condition.value, state);
        case conditionTypes.notBeginWith:
            return checkNotBeginWith(element, elementValue, condition.value, state);
        case conditionTypes.endsWith:
            return checkEndsWith(element, elementValue, condition.value, state);
        case conditionTypes.notEndWith:
            return checkNotEndWith(element, elementValue, condition.value, state);
        case conditionTypes.matchesAny:
            return checkMatchesAny(element, elementValue, condition.value, state);
        case conditionTypes.notMatchAny:
            return checkNotMatchAny(element, elementValue, condition.value, state);
        case conditionTypes.matchesAnyMaskedMulti:
            return checkMatchesAnyMaskedMulti(element, elementValue, condition.value, state);
        case conditionTypes.notMatchAnyMaskedMulti:
            return !checkMatchesAnyMaskedMulti(element, elementValue, condition.value, state);
        case conditionTypes.matchesEvery:
            return checkMatchesEvery(element, elementValue, condition.value, state);
        case conditionTypes.notMatchEvery:
            return checkNotMatchEvery(element, elementValue, condition.value, state);
        case conditionTypes.earlierThanNow:
            return checkEarlierThanNow(element, elementValue, state);
        case conditionTypes.earlierThanNowOrEqual:
            return checkEarlierThanNowOrEqual(element, elementValue, state);
        case conditionTypes.laterThanNow:
            return checkLaterThanNow(element, elementValue, state);
        case conditionTypes.laterThanNowOrEqual:
            return checkLaterThanNowOrEqual(element, elementValue, state);
        case conditionTypes.today:
            return checkToday(element, elementValue);
        case conditionTypes.notToday:
            return checkNotToday(element, elementValue);
        case conditionTypes.thisWeek:
            return checkThisWeek(element, elementValue);
        case conditionTypes.notThisWeek:
            return checkNotThisWeek(element, elementValue);
        case conditionTypes.thisMonth:
            return checkThisMonth(element, elementValue);
        case conditionTypes.notThisMonth:
            return checkNotThisMonth(element, elementValue);
        case conditionTypes.thisYear:
            return checkThisYear(element, elementValue);
        case conditionTypes.notThisYear:
            return checkNotThisYear(element, elementValue);
        case conditionTypes.between:
            return checkBetween(element, elementValue, condition.value, state);
        case conditionTypes.notBetween:
            return checkNotBetween(element, elementValue, condition.value, state);
        case conditionTypes.last:
            return checkLast(element, elementValue, condition.value, state);
        case conditionTypes.notLast:
            return checkNotLast(element, elementValue, condition.value, state);
        case conditionTypes.next:
            return checkNext(element, elementValue, condition.value, state);
        case conditionTypes.notNext:
            return checkNotNext(element, elementValue, condition.value, state);
    }
}
exports.elementConditionReducer = elementConditionReducer;
/**
 * Function that will evaluate conditions that deal with programs
 * @param state form state
 * @param condition program condition
 */
function programConditionReducer(state, condition) {
    var allPrograms = state.allPrograms;
    var selectedPrograms = form_definition_1.getSelectedPrograms(state);
    switch (condition.type) {
        case conditionTypes.programEmpty:
            return programOperators.hasEmptyProgramValue(selectedPrograms);
        case conditionTypes.programNotEmpty:
            return !programOperators.hasEmptyProgramValue(selectedPrograms);
        case conditionTypes.programContains:
            return programOperators.programNameContains(selectedPrograms, allPrograms, condition.value);
        case conditionTypes.programNotContains:
            return !programOperators.programNameContains(selectedPrograms, allPrograms, condition.value);
        case conditionTypes.programMatchesAny:
            return programOperators.programAnySelected(selectedPrograms, condition.value);
        case conditionTypes.programNotMatchesAny:
            return !programOperators.programAnySelected(selectedPrograms, condition.value);
        case conditionTypes.programMatchesAll:
            return programOperators.programAllSelected(selectedPrograms, condition.value);
        case conditionTypes.programNotMatchesAll:
            return !programOperators.programAllSelected(selectedPrograms, condition.value);
        default:
            return false;
    }
}
exports.programConditionReducer = programConditionReducer;
/**
 * Determines if a group element has sufficient information to be evaluated by conditional rules
 * @param groupElement the group element to evaluate
 * @param condition the condition evaluating it
 */
function isValidGroup(groupElement, condition) {
    if (groupElement.dataFormat && groupElement.dataFormat.type !== form_constants_1.dataFormatType.NONE)
        return true;
    if (condition.type === conditionTypes.empty || condition.type === conditionTypes.notEmpty)
        return true;
    return false;
}
/**
 * Determines if element value and condition value are equal for text, email, date, and zip
 * @param element
 * @param elementValue
 * @param conditionValue
 * @param formState
 */
function textEqualityCheck(elementValue, conditionValue) {
    // need to do a case-insensitive compare
    var stringValue = elementValue;
    var conditionString = conditionValue;
    if (stringValue == null && conditionString == null) {
        // both null
        return true;
    }
    if (stringValue == null || conditionString == null) {
        // only one null
        return false;
    }
    // neither one is null; do a case insensitive comparison.
    // MUST trim spaces first.
    return stringValue.trim().toLowerCase() === conditionString.trim().toLowerCase();
}
/**
* This function handles comparing equalilty for a given element and a provided value for various element types
* @param {FormElement} element the form element that is being evaluated by the condition
* @param {any} elementValue  the value of the element being evaluated
* @param {any} conditionValue the value on the condition
*/
function checkEquality(element, elementValue, conditionValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio: {
            var mcValue = elementValue && elementValue.toJS();
            return utilities_1.arrayExtensions.compareArrays(mcValue, conditionValue);
        }
        case form_definition_1.elementTypes.number: {
            var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
            var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
            return numberValue === conditionNumber;
        }
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.email:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.date: {
            return textEqualityCheck(elementValue, conditionValue);
        }
        case form_definition_1.elementTypes.time: {
            if (form_definition_1.hasEmptyValue(element, elementValue, formState))
                return false;
            var timeString = utilities_1.timeUtilities.getTimeString(elementValue, element.isMilitaryTime);
            var timeValue = moment.utc(timeString, 'HH:mm:ss');
            var conditionTime = moment.utc(conditionValue, 'HH:mm:ss');
            return timeValue.isSame(conditionTime, 'minute');
        }
        case form_definition_1.elementTypes.group: {
            switch (element.dataFormat.type) {
                case form_constants_1.dataFormatType.ZIP_EXTENSION: {
                    return textEqualityCheck(elementValue, conditionValue);
                }
                default: return false;
            }
        }
        default:
            return elementValue === conditionValue;
    }
}
/**
 * This function handles comparing equalilty for a given element and a provided value for various element types
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {any} conditionValue the value on the condition
 */
function checkEqualityLabel(element, elementValue, conditionValue, formState) {
    if (!elementValue || elementValue === undefined || elementValue === null) {
        return false;
    }
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.radio: {
            var condition = conditionValue.split("|").map(function (val) { return val.toLowerCase(); });
            var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.label.toLowerCase(); });
            return utilities_1.arrayExtensions.compareArrays(mcValue, condition);
        }
        case form_definition_1.elementTypes.group: {
            switch (element.dataFormat.type) {
                case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER: {
                    if (!elementValue)
                        return false;
                    var condition_1 = conditionValue.split("|").map(function (val) { return val.toLowerCase(); });
                    var mcValue_1 = form_definition_1.groupDataFormatHelpers.getMCOtherLabels(element, elementValue, formState).map(function (result) { return result.toLowerCase(); });
                    return utilities_1.arrayExtensions.compareArrays(mcValue_1, condition_1);
                }
                default: return false;
            }
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * This function handles comparing equalilty for a given element and a provided value for various element types
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {any} conditionValue the value on the condition
 */
function checkEqualityMaskedMulti(element, elementValue, conditionValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert: {
            var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.numValue; });
            var mcNumValue = utilities_1.numberUtilities.stringToNumber(mcValue[0]);
            var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
            return mcNumValue === conditionNumber;
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element has an empty value for various element types
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkEmpty(element, elementValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert: {
            var mcValue = elementValue && elementValue.toJS();
            return !mcValue || mcValue.length <= 0;
        }
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.date: {
            // Null, empty string, and whitespace all count as empty.
            return !elementValue || elementValue === '' || elementValue.trim() === '';
        }
        default:
            return form_definition_1.hasEmptyValue(element, elementValue, state);
    }
}
/**
 * checks to see if an element value contains a given value for various element types
 * **NOTE**: for multiple choice, an array of values shoudl be provided for the conditionValue,
 * and **all** of those values in the array must be selected for the function to return true
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value on the condition
 */
function checkContains(element, elementValue, conditionValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert: {
            var mcValue = elementValue && elementValue.toJS();
            return !!mcValue && !!conditionValue && conditionValue.every(function (choiceValue) { return mcValue.includes(choiceValue); });
        }
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.email: {
            return !!elementValue && !!conditionValue && elementValue.trim().toLocaleUpperCase().includes(conditionValue.trim().toLocaleUpperCase());
        }
        default:
            return elementValue === conditionValue;
    }
}
/**
 * checks to see if an element value contains a given string (case-insensitive) for various element types.
 * The percent symbol (%) is used as a wildcard, meaning it will match any character in its position in the string.
 * **NOTE**: for multiple choice, this means that if **any** value
 * in the set of elementValues contains the conditionValue, the function returns true
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {string} conditionValue the value to check if the element's value contains
 */
function checkContainsString(element, elementValue, conditionValue, state) {
    // make case-insensitive
    var conditionStr = conditionValue.trim().toLocaleUpperCase();
    // regex format
    conditionStr = utilities_1.textUtilities.convertStrToRegExStr(conditionStr);
    // account for wildcard with regex symbol for wildcard
    conditionStr = conditionStr.replace(RegExp("%", "g"), ".");
    var conditionRegex = RegExp(conditionStr);
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert: {
            var mcElement = element;
            var options_1 = mcElement.options;
            var mcValue = elementValue && elementValue.toJS();
            return !!mcValue && !!conditionRegex && mcValue.some(function (choiceValue) {
                return options_1.find(function (opt) { return opt.value === choiceValue && conditionRegex.test(opt.label.trim().toLocaleUpperCase()); });
            });
        }
        case form_definition_1.elementTypes.group: {
            switch (element.dataFormat.type) {
                case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER: {
                    if (!elementValue)
                        return false;
                    var mcValue = form_definition_1.groupDataFormatHelpers.getMCOtherLabels(element, elementValue, state);
                    return !!mcValue && !!conditionRegex && mcValue.some(function (choiceValue) { return conditionRegex.test(choiceValue.trim().toLocaleUpperCase()); });
                }
                case form_constants_1.dataFormatType.ZIP_EXTENSION: {
                    return !!elementValue && !!conditionRegex && conditionRegex.test(elementValue.trim().toLocaleUpperCase());
                }
                default: return false;
            }
        }
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.email: {
            return !!elementValue && !!conditionRegex && conditionRegex.test(elementValue.trim().toLocaleUpperCase());
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value does not contain a given string (case-insensitive) for various element types.
 * The percent symbol (%) is used as a wildcard, meaning it will match any character in its position in the string.
 * **NOTE**: for multiple choice, this means that if **any** value
 * in the set of elementValues contains the conditionValue, the function returns false
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {string} conditionValue the value to check if the element's value does not contain
 */
function checkNotContainString(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.email:
        case form_definition_1.elementTypes.group: {
            return !checkContainsString(element, elementValue, conditionValue, state);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if the value of an element is equal to the value of another element.
 * the condition value is equal to the elementId of the element to be compared.
 * the function handles the comparison for various element types of both the given element,
 * and the comparison element. when two elements cannot be compared the function returns false.
 * @param {FormState} state
 * @param {FormElement} element
 * @param {any} elementValue
 * @param {any} comparisonElementId
 */
function checkEqualElement(state, element, elementValue, comparisonElementId) {
    var comparisonElement = form_definition_1.getElementById(state, comparisonElementId);
    var comparisonValue = form_definition_1.getValue(state, comparisonElementId);
    if (!comparisonElement)
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert: {
            var mcValue = elementValue && elementValue.toJS();
            var choice = (mcValue && mcValue.length > 0) ? element.options.find(function (val) { return val.value === mcValue[0]; }) : undefined;
            var label = choice && choice.label;
            switch (comparisonElement.type) {
                case form_definition_1.elementTypes.select:
                case form_definition_1.elementTypes.radio:
                case form_definition_1.elementTypes.likert: {
                    var mcCompareValue = comparisonValue && comparisonValue.toJS();
                    if (!comparisonElement)
                        return false;
                    var comparisonChoice = (mcCompareValue && mcCompareValue.length > 0) ?
                        comparisonElement.options.find(function (val) { return val.value === mcCompareValue[0]; }) : undefined;
                    var comparisonLabel = comparisonChoice && comparisonChoice.label;
                    return label === comparisonLabel;
                }
                case form_definition_1.elementTypes.text:
                case form_definition_1.elementTypes.gisCoordinates:
                case form_definition_1.elementTypes.textArea: {
                    if (!label) {
                        if (!comparisonValue) {
                            return true;
                        }
                        else if (comparisonValue.trim() === '') {
                            return true;
                        }
                    }
                    return label != null && comparisonValue != null && label.trim().toLocaleUpperCase() === comparisonValue.trim().toLocaleUpperCase();
                }
                default:
                    return false;
            }
        }
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.textArea: {
            switch (comparisonElement.type) {
                case form_definition_1.elementTypes.select:
                case form_definition_1.elementTypes.radio:
                case form_definition_1.elementTypes.likert: {
                    var mcCompareValue = comparisonValue && comparisonValue.toJS();
                    if (!comparisonElement)
                        return false;
                    var comparisonChoice = (mcCompareValue && mcCompareValue.length > 0) ?
                        comparisonElement.options.find(function (val) { return val.value === mcCompareValue[0]; }) : undefined;
                    var comparisonLabel = comparisonChoice && comparisonChoice.label;
                    if (!comparisonLabel) {
                        if (!elementValue) {
                            return true;
                        }
                        else if (elementValue.trim() === '') {
                            return true;
                        }
                    }
                    return elementValue != null && comparisonLabel != null && elementValue.trim().toLocaleUpperCase() === comparisonLabel.trim().toLocaleUpperCase();
                }
                case form_definition_1.elementTypes.text:
                case form_definition_1.elementTypes.gisCoordinates:
                case form_definition_1.elementTypes.textArea: {
                    if (!elementValue) {
                        if (!comparisonValue) {
                            return true;
                        }
                        else if (comparisonValue.trim() === '') {
                            return true;
                        }
                    }
                    return elementValue != null && comparisonValue != null && elementValue.trim().toLocaleUpperCase() === comparisonValue.trim().toLocaleUpperCase();
                }
                default:
                    return false;
            }
        }
        case form_definition_1.elementTypes.number:
            switch (comparisonElement.type) {
                case form_definition_1.elementTypes.number:
                    var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
                    var conditionNumber = utilities_1.numberUtilities.stringToNumber(comparisonValue);
                    return numberValue === conditionNumber;
                default: return false;
            }
        default:
            return elementValue === comparisonValue;
    }
}
/**
 * This function checks if the elementvalue is less than a constant value for numeric element types
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {string | number} conditionValue the value on the condition
 */
function checkLessThan(element, elementValue, conditionValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.number: {
            var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
            var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
            return numberValue < conditionNumber;
        }
        case form_definition_1.elementTypes.time: {
            var timeString = utilities_1.timeUtilities.getTimeString(elementValue, element.isMilitaryTime);
            var timeValue = moment.utc(timeString, 'HH:mm:ss');
            var conditionTime = moment.utc(conditionValue, 'HH:mm:ss');
            return timeValue.isBefore(conditionTime, 'minute');
        }
        case form_definition_1.elementTypes.date: {
            var comparisonValue = moment(conditionValue, 'MM/DD/YYYY');
            var recordValue = moment(elementValue, 'MM/DD/YYYY');
            return recordValue.isBefore(comparisonValue, 'day');
        }
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.select:
            {
                var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.numValue; });
                var mcNumValue = utilities_1.numberUtilities.stringToNumber(mcValue[0]);
                var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
                return mcNumValue < conditionNumber;
            }
        default: return false;
    }
}
/**
* This function checks if the elementvalue is less than or equal than a constant for numeric element types
* @param {FormElement} element the form element that is being evaluated by the condition
* @param {any} elementValue  the value of the element being evaluated
* @param {string | number} conditionValue the value on the condition
*/
function checkLessThanOrEqual(element, elementValue, conditionValue, formState) {
    switch (element.type) {
        case form_definition_1.elementTypes.number: {
            return !checkGreaterThan(element, elementValue, conditionValue, formState);
        }
        case form_definition_1.elementTypes.time: {
            if (form_definition_1.hasEmptyValue(element, elementValue, formState))
                return false;
            return !checkGreaterThan(element, elementValue, conditionValue, formState);
        }
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue, formState))
                return false;
            var comparisonValue = moment(conditionValue, 'MM/DD/YYYY');
            var recordValue = moment(elementValue, 'MM/DD/YYYY');
            return recordValue.isSameOrBefore(comparisonValue, 'day');
        }
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.select:
            {
                var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.numValue; });
                var mcNumValue = utilities_1.numberUtilities.stringToNumber(mcValue[0]);
                var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
                return mcNumValue <= conditionNumber;
            }
        default: return false;
    }
}
/**
 * This function checks if the elementvalue is greater than a constant for numeric element types
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {string | number} conditionValue the value on the condition
 */
function checkGreaterThan(element, elementValue, conditionValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.number: {
            var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
            var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
            return numberValue > conditionNumber;
        }
        case form_definition_1.elementTypes.time: {
            var timeString = utilities_1.timeUtilities.getTimeString(elementValue, element.isMilitaryTime);
            var timeValue = moment.utc(timeString, 'HH:mm:ss');
            var conditionTime = moment.utc(conditionValue, 'HH:mm:ss');
            return timeValue.isAfter(conditionTime, 'minute');
        }
        case form_definition_1.elementTypes.date: {
            var comparisonValue = moment(conditionValue, 'MM/DD/YYYY');
            var recordValue = moment(elementValue, 'MM/DD/YYYY');
            return recordValue.isAfter(comparisonValue, 'day');
        }
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.select:
            {
                var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.numValue; });
                var mcNumValue = utilities_1.numberUtilities.stringToNumber(mcValue[0]);
                var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
                return mcNumValue > conditionNumber;
            }
        default: return false;
    }
}
/**
 * This function checks if the elementvalue is greater than or equal than a constant for numeric element types
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {string | number} conditionValue the value on the condition
 */
function checkGreaterThanOrEqual(element, elementValue, conditionValue, formState) {
    switch (element.type) {
        case form_definition_1.elementTypes.number: {
            return !checkLessThan(element, elementValue, conditionValue, formState);
        }
        case form_definition_1.elementTypes.time: {
            if (form_definition_1.hasEmptyValue(element, elementValue, formState))
                return false;
            return !checkLessThan(element, elementValue, conditionValue, formState);
        }
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue, formState))
                return false;
            var comparisonValue = moment(conditionValue, 'MM/DD/YYYY');
            var recordValue = moment(elementValue, 'MM/DD/YYYY');
            return recordValue.isSameOrAfter(comparisonValue, 'day');
        }
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.select:
            {
                var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.numValue; });
                var mcNumValue = utilities_1.numberUtilities.stringToNumber(mcValue[0]);
                var conditionNumber = utilities_1.numberUtilities.stringToNumber(conditionValue);
                return mcNumValue >= conditionNumber;
            }
        default: return false;
    }
}
/**
 * This function checks if the elementvalue is less than for a given element for numeric element types
 * @param {FormState} state the form state containing all elements
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {string} comparisonElementId the id of the comparison element
 */
function checkLessThanElement(state, element, elementValue, comparisonElementId) {
    var form = state.form;
    var elements = (form || new form_definition_1.Form({})).elements;
    var comparisonElement = form_definition_1.getElementById(state, comparisonElementId);
    var comparisonValue = form_definition_1.getValue(state, comparisonElementId);
    if (!comparisonElement)
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.number:
            switch (comparisonElement.type) {
                case form_definition_1.elementTypes.number:
                    var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
                    var comparisonNumber = utilities_1.numberUtilities.stringToNumber(comparisonValue);
                    return numberValue < comparisonNumber;
                default: return false;
            }
        default: return false;
    }
}
/**
 * This function checks if the elementvalue is less than for a given element for numeric element types
 * @param {FormState} state the form state containing all elements
 * @param {object} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {string} comparisonElementId the id of the comparison element
 */
function checkLessThanOrEqualElement(state, element, elementValue, comparisonElementId) {
    var form = state.form;
    var elements = (form || new form_definition_1.Form({})).elements;
    var comparisonElement = form_definition_1.getElementById(state, comparisonElementId);
    var comparisonValue = form_definition_1.getValue(state, comparisonElementId);
    if (!comparisonElement)
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.number:
            switch (comparisonElement.type) {
                case form_definition_1.elementTypes.number:
                    var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
                    var comparisonNumber = utilities_1.numberUtilities.stringToNumber(comparisonValue);
                    return numberValue <= comparisonNumber;
                default: return false;
            }
        default: return false;
    }
}
/**
 * This function checks if the elementvalue is greater than for a given element for numeric element types
 * @param {FormState} state the form state containing all elements
 * @param {object} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {string} conditionValue the id of the comparison element
 */
function checkGreaterThanElement(state, element, elementValue, comparisonElementId) {
    var form = state.form;
    var elements = (form || new form_definition_1.Form({})).elements;
    var comparisonElement = form_definition_1.getElementById(state, comparisonElementId);
    var comparisonValue = form_definition_1.getValue(state, comparisonElementId);
    if (!comparisonElement)
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.number:
            switch (comparisonElement.type) {
                case form_definition_1.elementTypes.number:
                    var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
                    var comparisonNumber = utilities_1.numberUtilities.stringToNumber(comparisonValue);
                    return numberValue > comparisonNumber;
                default: return false;
            }
        default: return false;
    }
}
/**
 * This function checks if the elementvalue is greater than for a given element for numeric element types
 * @param {FormState} state the form state containing all elements
 * @param {object} element the form element that is being evaluated by the condition
 * @param {any} elementValue  the value of the element being evaluated
 * @param {string} conditionValue the id of the comparison element
 */
function checkGreaterThanOrEqualElement(state, element, elementValue, comparisonElementId) {
    var form = state.form;
    var elements = (form || new form_definition_1.Form({})).elements;
    var comparisonElement = form_definition_1.getElementById(state, comparisonElementId);
    var comparisonValue = form_definition_1.getValue(state, comparisonElementId);
    if (!comparisonElement)
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.number:
            switch (comparisonElement.type) {
                case form_definition_1.elementTypes.number:
                    var numberValue = utilities_1.numberUtilities.stringToNumber(elementValue);
                    var comparisonNumber = utilities_1.numberUtilities.stringToNumber(comparisonValue);
                    return numberValue >= comparisonNumber;
                default: return false;
            }
        default: return false;
    }
}
/**
 * checks to see if an element value begins with a given string (case-insensitive) for various element types
 * **NOTE**: for multiple choice means that all of the given values are selected, and if **any** value
 * in the set begins with the conditionValue, the function returns true
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {string} conditionValue string to check the elementValue begins with
 */
function checkBeginsWith(element, elementValue, conditionValue, state) {
    // make case-insensitive
    var conditionStr = conditionValue.trim().toLocaleUpperCase();
    // regex format
    conditionStr = utilities_1.textUtilities.convertStrToRegExStr(conditionStr);
    // account for wildcard with regex symbol for wildcard
    conditionStr = conditionStr.replace(RegExp("%", "g"), ".");
    var conditionRegex = RegExp("^" + conditionStr);
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert: {
            var mcElement = element;
            var options_2 = mcElement.options;
            var mcValue = elementValue && elementValue.toJS();
            return !!mcValue && !!conditionRegex && mcValue.some(function (choiceValue) {
                return options_2.find(function (opt) { return opt.value === choiceValue && conditionRegex.test(opt.label.trim().toLocaleUpperCase()); });
            });
        }
        case form_definition_1.elementTypes.group: {
            switch (element.dataFormat.type) {
                case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER: {
                    if (!elementValue)
                        return false;
                    var mcValue = form_definition_1.groupDataFormatHelpers.getMCOtherLabels(element, elementValue, state);
                    return !!mcValue && !!conditionRegex && mcValue.some(function (choiceValue) { return conditionRegex.test(choiceValue.trim().toLocaleUpperCase()); });
                }
                case form_constants_1.dataFormatType.ZIP_EXTENSION: {
                    return !!elementValue && !!conditionRegex && conditionRegex.test(elementValue.trim().toLocaleUpperCase());
                }
                default: return false;
            }
        }
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.email: {
            return !!elementValue && !!conditionRegex && conditionRegex.test(elementValue.trim().toLocaleUpperCase());
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value does not begin with a given string (case-insensitive) for various element types
 * **NOTE**: for multiple choice means that all of the given values are selected, and if **any** value
 * in the set begins with the conditionValue, the function returns false
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {string} conditionValue string to check the elementValue does not begin with
 */
function checkNotBeginWith(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.email:
        case form_definition_1.elementTypes.group: {
            return !checkBeginsWith(element, elementValue, conditionValue, state);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value ends with a given string (case-insensitive) for various element types
 * **NOTE**: for multiple choice means that all of the given values are selected, and if **any** value
 * in the set ends with the conditionValue, the function returns true
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {string} conditionValue string to check the elementValue ends with
 */
function checkEndsWith(element, elementValue, conditionValue, state) {
    // make case-insensitive
    var conditionStr = conditionValue.trim().toLocaleUpperCase();
    // regex format
    conditionStr = utilities_1.textUtilities.convertStrToRegExStr(conditionStr);
    // account for wildcard with regex symbol for wildcard
    conditionStr = conditionStr.replace(RegExp("%", "g"), ".");
    var conditionRegex = RegExp(conditionStr + "$");
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert: {
            var mcElement = element;
            var options_3 = mcElement.options;
            var mcValue = elementValue && elementValue.toJS();
            return !!mcValue && !!conditionRegex && mcValue.some(function (choiceValue) {
                return options_3.find(function (opt) { return opt.value === choiceValue && conditionRegex.test(opt.label.trim().toLocaleUpperCase()); });
            });
        }
        case form_definition_1.elementTypes.group: {
            switch (element.dataFormat.type) {
                case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER: {
                    if (!elementValue)
                        return false;
                    var mcValue = form_definition_1.groupDataFormatHelpers.getMCOtherLabels(element, elementValue, state);
                    return !!mcValue && !!conditionRegex && mcValue.some(function (choiceValue) { return conditionRegex.test(choiceValue.trim().toLocaleUpperCase()); });
                }
                case form_constants_1.dataFormatType.ZIP_EXTENSION: {
                    return !!elementValue && !!conditionRegex && conditionRegex.test(elementValue.trim().toLocaleUpperCase());
                }
                default: return false;
            }
        }
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.email: {
            return !!elementValue && !!conditionRegex && conditionRegex.test(elementValue.trim().toLocaleUpperCase());
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value does not end with a given string (case-insensitive) for various element types
 * **NOTE**: for multiple choice means that all of the given values are selected, and if **any** value
 * in the set ends with the conditionValue, the function returns false
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {string} conditionValue string to check the elementValue does not end with
 */
function checkNotEndWith(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.text:
        case form_definition_1.elementTypes.textArea:
        case form_definition_1.elementTypes.gisCoordinates:
        case form_definition_1.elementTypes.email:
        case form_definition_1.elementTypes.group: {
            return !checkEndsWith(element, elementValue, conditionValue, state);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value matches any one of a set of values
 * **NOTE**: for multiple choice means that all of the given values are selected, and if **any** value
 * in the set matches any of the conditionValue, the function returns true
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkMatchesAny(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.checkbox: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            var choiceValueArray = !conditionValue ? [] : conditionValue.split("|");
            var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.label; });
            return !!mcValue && !!conditionValue && mcValue.some(function (choiceValue) { return choiceValueArray.includes(choiceValue); });
        }
        case form_definition_1.elementTypes.group: {
            switch (element.dataFormat.type) {
                case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER: {
                    if (!elementValue)
                        return false;
                    var choiceValueArray_1 = conditionValue ? conditionValue.split("|") : [];
                    var mcValue_2 = form_definition_1.groupDataFormatHelpers.getMCOtherLabels(element, elementValue, state);
                    return !!mcValue_2 && mcValue_2.some(function (choiceValue) { return choiceValueArray_1.includes(choiceValue); });
                }
                default: return false;
            }
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value does not match any one of a set of values
 * **NOTE**: for multiple choice means that all of the given values are selected, and if **any** value
 * in the set matches any of the conditionValue, the function returns false
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkNotMatchAny(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.group: {
            return !checkMatchesAny(element, elementValue, conditionValue, state);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value matches any one of a set of values
 * **NOTE**: for multiple choice means that all of the given values are selected, and if **any** value
 * in the set matches any of the conditionValue, the function returns true
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkMatchesAnyMaskedMulti(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.likert: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            var choiceValueArray = !conditionValue ? [] : conditionValue.split("|");
            var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.numValue; });
            var mcNumValueArray = mcValue.map(Number);
            var choiceNumValueArray = choiceValueArray.map(Number);
            return !!mcNumValueArray && !!choiceNumValueArray && mcNumValueArray.some(function (choiceValue) { return choiceNumValueArray.includes(choiceValue); });
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value matches all of a set of values
 * This means that all values in the conditionValue set must be satisfied by a subset of the elementValue
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against, of which, all items must be matched
 */
function checkMatchesEvery(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            var choiceValueArray = !conditionValue ? [] : conditionValue.split("|");
            var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.label; });
            return !!mcValue && !!conditionValue && choiceValueArray.every(function (choiceValue) { return mcValue.includes(choiceValue); });
        }
        case form_definition_1.elementTypes.group: {
            switch (element.dataFormat.type) {
                case form_constants_1.dataFormatType.MULTIPLE_CHOICE_OTHER: {
                    if (!elementValue)
                        return false;
                    var choiceValueArray_2 = conditionValue ? conditionValue.split("|") : [];
                    var mcValue_3 = form_definition_1.groupDataFormatHelpers.getMCOtherLabels(element, elementValue, state);
                    return !!mcValue_3 && choiceValueArray_2.every(function (choiceValue) { return mcValue_3.includes(choiceValue); });
                }
                default: return false;
            }
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value does not match all of a set of values
 * This means that all values in the conditionValue set must be satisfied by a subset of
 *  the elementValue for this check to fail
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkNotMatchEvery(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.select:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.group: {
            return !checkMatchesEvery(element, elementValue, conditionValue, state);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value is earlier than now
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkEarlierThanNow(element, elementValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.time: {
            var timeString = utilities_1.timeUtilities.getTimeString(elementValue, element.isMilitaryTime);
            var time = moment.utc(timeString, 'HH:mm:ss');
            return time.isBefore(moment.utc());
        }
    }
}
/**
 * checks to see if an element value is earlier than now or equal
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkEarlierThanNowOrEqual(element, elementValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.time: {
            return !checkLaterThanNow(element, elementValue, formState);
        }
    }
}
/**
 * checks to see if an element value is later than now
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkLaterThanNow(element, elementValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.time: {
            var timeString = utilities_1.timeUtilities.getTimeString(elementValue, element.isMilitaryTime);
            var time = moment.utc(timeString, 'HH:mm:ss');
            return time.isAfter(moment.utc());
        }
    }
}
/**
 * checks to see if an element value is later than or equal to now
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param formState
 */
function checkLaterThanNowOrEqual(element, elementValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.time: {
            return !checkEarlierThanNow(element, elementValue, formState);
        }
    }
}
/**
 * checks to see if an element value is between two constant values
 * This means that all values in the conditionValue set must be satisfied by a subset of
 *  the elementValue for this check to fail
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkBetween(element, elementValue, conditionValue, formState) {
    if (form_definition_1.hasEmptyValue(element, elementValue, formState))
        return false;
    switch (element.type) {
        case form_definition_1.elementTypes.number: {
            var numVal = Number(elementValue);
            if (!isNaN(numVal) && !!conditionValue && conditionValue.trim() !== "") {
                var conditionValues = conditionValue.split('|');
                // It is possible to get any of the following for condition values:
                // "22|44" (value is between 22 and 44)
                // "22" (value is greater than or equal to 22)
                // "|44" (value is less than or equal to 44)
                var condLoBound = Number(conditionValues[0]);
                if (conditionValues.length === 2) {
                    var condHiBound = Number(conditionValues[1]);
                    if (!isNaN(condLoBound) && !isNaN(condHiBound)) {
                        // valid numbers for both lobound and hibound
                        return numVal >= condLoBound && numVal <= condHiBound;
                    }
                    else if (!isNaN(condHiBound)) {
                        // only the hibound is valid
                        return numVal <= condHiBound;
                    }
                }
                else if (conditionValues.length === 1) {
                    var condLoBound = Number(conditionValues[0]);
                    if (!isNaN(condLoBound)) {
                        // only the lobound is valid
                        return numVal >= condLoBound;
                    }
                }
            }
            return false;
        }
        case form_definition_1.elementTypes.date: {
            var bounds = conditionValue.split('|').map(function (date) { return moment(date, 'MM/DD/YYYY'); });
            var lowerBound = moment.min(bounds);
            var upperBound = moment.max(bounds);
            return utilities_1.dateUtilities.isDateInRange(elementValue, lowerBound, upperBound);
        }
        case form_definition_1.elementTypes.time: {
            var bounds = conditionValue.split('|').map(function (time) { return moment.utc(time, 'hh:mm:ss'); });
            if (bounds.length !== 2)
                throw new Error("Invalid condition value for between operator: " + conditionValue);
            var lowerBound_1 = moment.min(bounds);
            var upperBound_1 = moment.max(bounds);
            var timeString = utilities_1.timeUtilities.getTimeString(elementValue, element.isMilitaryTime);
            var timeValue = moment.utc(timeString, 'HH:mm:ss');
            return timeValue.isBetween(lowerBound_1, upperBound_1, 'minute', '()');
        }
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.select: {
            var mcValue = element.options.filter(function (opt) { return elementValue.toArray().includes(opt.value); }).map(function (result) { return result.numValue; });
            if (!!mcValue && !!conditionValue && conditionValue.trim() !== "") {
                var mcNumValue = Number(mcValue[0]);
                var conditionValues = conditionValue.split('|');
                // It is possible to get any of the following for condition values:
                // "22|44" (value is between 22 and 44)
                // "22" (value is greater than or equal to 22)
                // "|44" (value is less than or equal to 44)
                var condLoBound = Number(conditionValues[0]);
                if (conditionValues.length === 2) {
                    var condHiBound = Number(conditionValues[1]);
                    if (!isNaN(condLoBound) && !isNaN(condHiBound)) {
                        // valid numbers for both lobound and hibound
                        return mcNumValue >= condLoBound && mcNumValue <= condHiBound;
                    }
                    else if (!isNaN(condHiBound)) {
                        // only the hibound is valid
                        return mcNumValue <= condHiBound;
                    }
                }
                else if (conditionValues.length === 1) {
                    var condLoBound = Number(conditionValues[0]);
                    if (!isNaN(condLoBound)) {
                        // only the lobound is valid
                        return mcNumValue >= condLoBound;
                    }
                }
            }
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value is not between two constant values
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkNotBetween(element, elementValue, conditionValue, formState) {
    switch (element.type) {
        case form_definition_1.elementTypes.number:
        case form_definition_1.elementTypes.date:
        case form_definition_1.elementTypes.time:
        case form_definition_1.elementTypes.likert:
        case form_definition_1.elementTypes.checkbox:
        case form_definition_1.elementTypes.radio:
        case form_definition_1.elementTypes.select: {
            return !checkBetween(element, elementValue, conditionValue, formState);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value matches today
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkToday(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            var today = moment().format('MM/DD/YYYY');
            return today === elementValue;
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value does not match today
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkNotToday(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            return !checkToday(element, elementValue);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value matches a value in the current week
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkThisWeek(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            var recordValue = moment(elementValue, 'MM/DD/YYYY');
            return moment().isSame(recordValue, 'isoWeek');
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value does not match a value in the current week
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkNotThisWeek(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            return !checkThisWeek(element, elementValue);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value matches a value in the current month
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkThisMonth(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            var recordValue = moment(elementValue, 'MM/DD/YYYY');
            return moment().isSame(recordValue, 'month');
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value does not match a value in the current month
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkNotThisMonth(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            return !checkThisMonth(element, elementValue);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value matches a value in the current year
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkThisYear(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            var recordValue = moment(elementValue, 'MM/DD/YYYY');
            return moment().isSame(recordValue, 'year');
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an date element value does not match a value in the current year
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 */
function checkNotThisYear(element, elementValue) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue)) {
                return false;
            }
            return !checkThisYear(element, elementValue);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value is within certain number of days
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkLast(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue, state)) {
                return false;
            }
            var diff = moment().diff(elementValue, 'days');
            if (Math.sign(diff) >= 0) {
                return +conditionValue >= diff;
            }
            return false;
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value is not within certain number of days
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkNotLast(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue, state)) {
                return false;
            }
            return !checkLast(element, elementValue, conditionValue, state);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value is within certain number of days
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkNext(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue, state)) {
                return false;
            }
            var start = moment().add(1, 'd');
            var diff = moment(elementValue).diff(start, 'days');
            if (Math.sign(diff) >= 0) {
                return +conditionValue >= diff;
            }
            return false;
        }
        default:
            // unsupported for other elements
            return false;
    }
}
/**
 * checks to see if an element value is not within certain number of days
 * @param {FormElement} element the form element that is being evaluated by the condition
 * @param {any} elementValue the value of the element being evaluated
 * @param {any} conditionValue the value set to check against
 */
function checkNotNext(element, elementValue, conditionValue, state) {
    switch (element.type) {
        case form_definition_1.elementTypes.date: {
            if (form_definition_1.hasEmptyValue(element, elementValue, state)) {
                return false;
            }
            return !checkNext(element, elementValue, conditionValue, state);
        }
        default:
            // unsupported for other elements
            return false;
    }
}
//# sourceMappingURL=condition.reducer.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/rules-engine/condition.reducer.js
// module id = 1154
// module chunks = 0